export const painPoints = [
  {
    emoji: '💸',
    title: 'No sabés cuánto cobrar',
    desc: 'Ponés precios "a ojo", vendés barato para no perder el cliente y al final del mes descubrís que trabajaste 40 horas para ganar casi nada. La inflación te come el margen sin que te des cuenta.',
  },
  {
    emoji: '📸',
    title: 'Tus fotos no generan ventas',
    desc: 'Publicás en Instagram, recibís "qué lindo" pero nadie pregunta el precio. Tus amigurumis son hermosos pero las fotos no hacen justicia. El que no sabe mostrar bien su producto, no vende.',
  },
  {
    emoji: '😤',
    title: 'Los clientes te regatean siempre',
    desc: 'Cada vez que ponés precio te dicen "uy, está caro" o "¿no me hacés un descuentito?". Sin saber cómo posicionar tu marca, siempre vas a competir por precio contra las que regalan su trabajo.',
  },
  {
    emoji: '📱',
    title: 'No sabés qué publicar en redes',
    desc: 'Abrís Instagram y te quedás paralizada. No sabés si subir fotos del proceso, del producto terminado o hacer Reels. Sin estrategia, publicás una vez y abandonás por semanas.',
  },
  {
    emoji: '📦',
    title: 'No tenés sistema de pedidos',
    desc: 'Todo entra por MD, te piden cambios de último momento, te cancelan encargos sin señas y terminás entregando tarde. Sin un sistema de gestión, tu negocio es un caos que te agota emocionalmente.',
  },
  {
    emoji: '🧭',
    title: 'No sabés por dónde empezar a vender',
    desc: 'Tenés las piezas y las ganas, pero el camino para llegar al cliente ideal está tan desordenado que no encontrás el foco. Sin método, solo tenés un hobby caro que te consume el tiempo libre.',
  },
];
